/**
 * Last pathname seen before the current router location (same-tab, in-memory).
 * Used when deciding whether `history.goBack()` is safe on company-scoped detail screens.
 */
let priorRouterPathname: string | undefined
let currentRouterPathname: string | undefined

export function recordRouterPathnameFromLocation(pathname: string): void {
    if (pathname === currentRouterPathname) {
        return
    }
    priorRouterPathname = currentRouterPathname
    currentRouterPathname = pathname
}

export function getPriorRouterPathnameForBrowserBack(): string | undefined {
    return priorRouterPathname
}
